import { Box, Button, Card, Container, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import api from "../../../components/services/api"
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import mime from "mime";
import { saveAs } from "file-saver";

export default function ReportEmpty() {
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const[data, setData] = useState([])
  
  const columns = [
    { field: "Voyage", headerName: "Voyage No.", width: 200 },
    { field: "Barge", headerName: "Barge name", width: 200 },
    { field: "Tug", headerName: "Tug", width: 200 },
    { field: "PortofLoading", headerName: "PortofLoading", width: 200 },
    { field: "PortofDischarge", headerName: "PortofDischarge", width: 200 },

    { field: "ETD", headerName: "ETD", width: 200,renderCell: (value) => {
      return(
        moment(value.row.ETD).format('yyyy/MM/DD')
      )


    } },
    { field: "ETA", headerName: "ETA", width: 200 , 
    renderCell: (value) => {
      return(
        moment(value.row.ETA).format('yyyy/MM/DD')
      )


    }
  },
    {
      field: "Action",
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Button
              variant="contained"
              style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              onClick={async () => {
                setLoading(true)
                await api.get(`api/report/report-empty-laden-container/download/excel?VoyNo=${params.row.Voyage}&ContainerGender=Empty`, {
                  responseType: "blob",
                  timeout: 30000
                })
                  .then((blobFile) => {
                    const blobFileRes = new File([blobFile?.data], "test.xlsx", {
                      type: mime.getType(".xlsx"),

                    });

                    // window.open(
                    //   URL.createObjectURL(blobFileRes, "test.csv"),
                    //   "_blank"
                    // );
                    saveAs(blobFileRes, "ReportEmpty.xlsx");
                    setLoading(false)
                  });

              }}>
              download
            </Button>
          </>
        );
      },
    },
  ];

  const search1 = async ()=>{
    const params = new URLSearchParams();

    if (dateStart)
      params.append("sdate", moment(dateStart).format("yyyy-MM-DD"));
    if (dateEnd) params.append("edate", moment(dateEnd).format("yyyy-MM-DD"));
    if (searchText) params.append("VoyNo", searchText);
    params.append("ContainerGender", 'Empty');
    const data = await  api.get(`/api/report/DataContainerPlanning/list?${params}`)

    const result = data?.data
    
    setData(result)
  }


  const getdata = async () => {
    const data = await api.get(`/api/report/DataContainerPlanning/list?ContainerGender=Empty`);

    const result = data?.data;

    setData(result);
  };

  useEffect(() => {
    getdata();
  }, []);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายงานตู้เปล่า
        </h6>
        <h3 style={{ marginTop: "10px" }} className="textcolordarkblue">
          Report Empty
        </h3>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <TextField
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="small"
            id="outlined-basic"
            label="Search Voy"
            variant="outlined"
          />

          <DesktopDatePicker
            label="Date Start"
            value={dateStart}
            onChange={ (newValue) => {
              setDateStart(moment(newValue).format('yyyy-MM-DD'));
              
            }}
            inputFormat="yyyy/MM/dd"
            minDate={new Date("2017-01-01")}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />
          <DesktopDatePicker
            label="Date End"
            value={dateEnd}
            inputFormat="yyyy/MM/dd"
            onChange={ (newValue) => {
              setDateEnd(moment(newValue).format('yyyy-MM-DD'));
              
            }}
            minDate={new Date(dateStart)}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
            }}
            onClick={search1}
          >
            <SearchIcon />
          </Button>
        </div>
        <Box sx={{height:'700px',marginTop:'25px'}}>
        <DataGrid
            getRowId={(r) => r.Voyage}
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            
          />
        </Box>
      </Card>
    </LocalizationProvider>
  );
}
